/** @file Copies the modifier flags of a key event into the shared state (Mod resolved per platform). */
import type { KeyEventLike } from '../types';
import { keyState } from './keyState';

/** Called for every key event, typing or not, so pointer tools always see current modifiers. */
export function updateModifiers(event: KeyEventLike): void {
  const m = keyState.modifiers;
  m.ctrl = event.ctrlKey;
  m.meta = event.metaKey;
  m.shift = event.shiftKey;
  m.alt = event.altKey;
  m.mod = keyState.platform === 'mac' ? m.meta : m.ctrl;
}
